export const WS_JOIN_ROOM = 'WEBSOCKETS/JOIN_ROOM'
export const WS_LEAVE_ROOM = 'WEBSOCKETS/LEAVE_ROOM'
export const WS_CLIENT_ACTION = 'WEBSOCKETS/CLIENT_ACTION'

// Lifecycle action types
export const WS_PRE_DISPATCH = 'WEBSOCKETS/PRE_DISPATCH'
export const WS_POST_DISPATCH = 'WEBSOCKETS/POST_DISPATCH'
